import classNames from 'classnames'
import getConfig from 'next/config'
import { memo, useMemo } from 'react'
import CustomImage from 'src/components/Image'
import useAppStore from 'src/hooks/business/use_app_store'
import useI18n from 'src/hooks/use_i18n'
import Styles from './index.module.scss'

const { publicRuntimeConfig } = getConfig()

const assetPrefix = publicRuntimeConfig.assetPrefix || ''

// #region component
interface Props {
  carrierName?: string
}

function WhatCanWeDo({ carrierName = '17track' }: Props) {
  const { $t, activeLocale: locale, i18nFormatAll } = useI18n()
  const { stores, browserInfoRef } = useAppStore()

  const appHref = useMemo(() => {
    if (browserInfoRef.isAndroid) {
      return `${stores[1].link}&utm_source=carriers&utm_medium=referer&utm_campaign=20250214-carriers-open-app`
    }

    if (browserInfoRef.isIos) {
      return `${stores[0].link}?utm_source=carriers&utm_medium=referer&utm_campaign=20250214-carriers-open-app`
    }
    return `//www.17track.net/${locale}/app?utm_source=carriers&utm_medium=referer&utm_campaign=20230130-carrier-open-app`
  }, [stores])

  const handleAppClick = () => {
    if (browserInfoRef.isAndroid) {
      return window.ga?.sendEvent?.('事件操作', `carriers-跳转google play`)
    }

    if (browserInfoRef.isIos) {
      return window.ga?.sendEvent?.('事件操作', `carriers-跳转app store`)
    }
    window.ga?.sendEvent?.('事件操作', 'carriers-点击跳转app落地页')
  }

  return (
    <>
      <section className={classNames('fixWidth', Styles['what-cando'])}>
        <h2>{i18nFormatAll($t('ResCarrierListPSeoDetails.global.__pWhatCanIDoProblem'), carrierName)}</h2>
        <div className={classNames(Styles['cando-content'])}>
          <div
            className={classNames(Styles['cando-box'])}
            onClick={() =>
              (location.href = `/${locale}/track_page?utm_source=carriers&utm_medium=referer&utm_campaign=20230130-carrier-open-shopify`)
            }
          >
            <div className="relative">
              <CustomImage
                src={assetPrefix + '/assets/images/carriers/carrier_info/cando_01'}
                loading="lazy"
                decoding="async"
                alt="17TRACK shopify landing page"
                fill
                className="lazy-image-fill"
              />
            </div>
            <p>
              {i18nFormatAll($t('ResCarrierListPSeoDetails.global.__pWhatCanIDo_shopifyText'), {
                carriersName: carrierName
              })}
            </p>
            <a href={`/${locale}/track_page?utm_source=www.17track.net&utm_medium=carriers&utm_campaign=Get-started`}>
              {$t('ResCarrierListPSeoDetails.global.__pWhatCanIDo_shopifyButton')}
              <i className={classNames('icon fa-arrow-forward', Styles['fa-arrow-forward'])}></i>
            </a>
          </div>
          <div
            className={classNames(Styles['cando-box'])}
            onClick={() =>
              (location.href = `//www.17track.net/api?utm_source=carriers&utm_medium=referer&utm_campaign=20230130-carrier-open-api`)
            }
          >
            <div className="relative">
              <CustomImage
                src={assetPrefix + '/assets/images/carriers/carrier_info/cando_02'}
                loading="lazy"
                decoding="async"
                alt="17TRACK API"
                fill
                className="lazy-image-fill"
              />
            </div>

            <p>
              {i18nFormatAll($t('ResCarrierListPSeoDetails.global.__pWhatCanIDo_apiText'), {
                carriersName: carrierName
              })}
            </p>
            <a
              href={`//www.17track.net/api?utm_source=carriers&utm_medium=referer&utm_campaign=20230130-carrier-open-api`}
            >
              {$t('ResCarrierListPSeoDetails.global.__pWhatCanIDo_apiButton')}
              <i className={classNames('icon fa-arrow-forward', Styles['fa-arrow-forward'])}></i>
            </a>
          </div>
          <div className={classNames(Styles['cando-box'])}>
            <div className="relative">
              <CustomImage
                src={assetPrefix + '/assets/images/carriers/carrier_info/cando_03'}
                loading="lazy"
                decoding="async"
                alt="17TRACK App"
                fill
                className="lazy-image-fill"
              />
            </div>

            <p>
              {i18nFormatAll($t('ResCarrierListPSeoDetails.global.__pWhatCanIDo_appText'), {
                carriersName: carrierName
              })}
            </p>
            <a href={appHref} target="_blank" onClick={handleAppClick}>
              {$t('ResCarrierListPSeoDetails.global.__pWhatCanIDo_appButton')}
              <i className={classNames('icon fa-arrow-forward', Styles['fa-arrow-forward'])}></i>
            </a>
          </div>
        </div>
      </section>
    </>
  )
}

export default memo(WhatCanWeDo)
